import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";

import {
  WithStyles,
  createStyles,
  Typography,
  Button,
  Modal,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Paper,
  Link,
  CircularProgress,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import CloseIcon from "@material-ui/icons/Close";

import { MyPATCollapse, MyPATLink, dateService } from "../../common";
import ACLService from "../../acl/services/aclService";
import ContentData from "../types/ContentData";
import { getGoalList } from "../../goal-management/actions/goalManagementActions";
import { assignTest, showMsg } from "../actions/testPaperCreateAction";

import env from "../../../config/config";
import RevisionHistoryModal from "./RevisionHistoryModal";
import { calCulateProgressBar } from "../../../utils";
import {
  toggleLicenseExpiredDialog,
  setLoggedInUser,
} from "../../login/actions/userActions";
import contentActions from "../actions/contentActions";
const styles = (theme: Theme) =>
  createStyles({
    contentLink: {
      color: "#1D7DEA",
      fontSize: 14,
      marginRight: 9,
      marginBottom: 10,
      display: "inline-block",
      '&:hover':{
        cursor: 'pointer',
      },
      "&:not(:last-child):after": {
        content: '", "',
        fontWeight: 400,
        textDecoration: "none",
        color: "black",
      },
    },
    contentContainer: {
      backgroundColor: "#F1F8FF;",
      padding: 10,
      minHeight: "120px",
      borderRadius: 12,
    },
    emptyStateText: {
      textAlign: "center",
      fontSize: "1rem",
    },
    subHeading: {
      fontSize: "16px",
      color: "#666666",
      padding: '20px 10px 10px 0',
    },
    progressText: {
      fontSize: "13px",
      opacity: 0.7,
      marginBottom: "6px",
    },
    keyValueContainer: {
      display: "flex",
      margin: "10px 0",
      fontSize: "14px",
      "&>p:nth-of-type(1)": {
        fontWeight: 700,
      },
    },
    modal: {
      display: "flex",
      padding: 12,
      alignItems: "center",
      justifyContent: "center",
    },
    modalHeader: {
      height: 60,
      borderBottom: "solid 1px #0004",
    },
    paper: {
      width: 680,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: "20, 40, 30",
      textAlign: "center",
    },
    root: {
      justifyContent: "center",
    },
    padding2X: {
      padding: "24px 0px 24px 100px",
    },
    formControl: {
      width: 200,
    },
    red: {
      color: "#F21D1D",
    },
    headingFont: {
      fontSize: "1.25rem",
      fontWeight: "bold",
    },
    subHeadingFont: {
      fontSize: "1rem",
      marginRight: 10,
    },
  });

//@ts-ignore
interface ContentSuggestionsProps extends WithStyles<typeof styles> {
  classes: any;
  suggestions: { similarContents: any[]; duplicateContents: any[] };
  contentType: string;
  contentId: string;
  setContentSuggestions: (params: { type: string; id: string }) => void;
  loader: boolean;
}

interface ContentSuggestionsStates {}
class ContentSuggestions extends Component<
  ContentSuggestionsProps,
  ContentSuggestionsStates
> {
  constructor(props: ContentSuggestionsProps) {
    super(props);
    // this.state = {

    // }
  }
  componentDidMount() {
    // const{setContentSuggestions,contentId,contentType}=this.props;
    // setContentSuggestions({id:contentId,type:contentType})
  }
  redirectUrl = (content: any) => {
    // console.log('url;;-', id);
    const { contentId, content_Id } = content;
    let firstLetter = contentId.charAt(0);
    let type = "question";
    if (firstLetter == "N") type = "note";
    if (firstLetter == "V") type = "videos";
    let url = "/content/preview/" + content_Id + type;
    window.open(url, "_blank");
  };
  render() {
    const { classes, suggestions, loader } = this.props;
    const { similarContents = [], duplicateContents = [] } = suggestions;
    return (
      <>
        <Grid>
          <Grid>
            <Typography className={classes.subHeading}>Duplicate Content</Typography>
            <Grid className={classes.contentContainer}>
              {loader ? (
                <div style={{ textAlign: "center" }}>
                  <CircularProgress />
                </div>
              ) : duplicateContents.length > 0 ? (
                duplicateContents.map((content: any) => {
                  return (
                    <Link
                      className={classes.contentLink}
                      onClick={() => {
                        this.redirectUrl(content);
                      }}
                    >
                      {content.contentId}
                    </Link>
                  );
                })
              ) : (
                <span className={classes.emptyStateText}>No Match Found !</span>
              )}
            </Grid>
          </Grid>
          <Grid>
            <Grid>
              <Typography className={classes.subHeading}>Similar Content</Typography>
              <Grid className={classes.contentContainer}>
                {loader ? (
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <CircularProgress />
                  </div>
                ) : similarContents.length > 0 ? (
                  similarContents.map((content: any) => {
                    return (
                      <Link
                        className={classes.contentLink}
                        onClick={() => {
                          this.redirectUrl(content);
                        }}
                      >
                        {content.contentId}
                      </Link>
                    );
                  })
                ) : (
                  <span className={classes.emptyStateText}>
                    No Match Found !
                  </span>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  suggestions: state.mylibraryData.content.contentSuggestions,
  loader: state.mylibraryData.loading,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setContentSuggestions: contentActions.setContentSuggestions,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(ContentSuggestions));
